import React, { useContext } from "react";
import "./singlestyles.scss";
import { ParentType } from "../../../../types/GlobalType";
import { parentContext } from "../../../../context/AppContext";

const ParentInfo = () => {
  const parentData: ParentType = useContext(parentContext);

  // console.log(parentData);
  return (
    <div
      className="tuteur_info"
      style={{
        overflowY: "auto",
      }}
    >
      <h4 className="title_section">Information Parent</h4>
      <table>
        <tr>
          <td>Nom:</td>
          <td>{parentData.nom?.toUpperCase()}</td>
        </tr>
        <tr>
          <td>Post-Nom:</td>
          <td>{parentData.postnom?.toUpperCase()}</td>
        </tr>
        <tr>
          <td>Prénom:</td>
          <td>{parentData.prenom?.toUpperCase()}</td>
        </tr>

        <tr>
          <td>Genre:</td>
          <td>
            {parentData.sexe?.toUpperCase() === "M" ? "MASCULIN" : "FEMININ"}
          </td>
        </tr>
        <tr>
          <td>Téléphone:</td>
          <td>{parentData.telephone}</td>
        </tr>
      </table>
      {/* <h4 className="title_section_2">Adresse résidentielle</h4> */}
      {/* <table>
        <tr>
          <td>Avenue:</td>
          <td>{parentData.avenue?.toUpperCase()}</td>
        </tr>
        <tr>
          <td>Quartier:</td>
          <td>{parentData.quartier?.toUpperCase()}</td>
        </tr>
        <tr>
          <td>Commune:</td>
          <td>{parentData.commune?.toUpperCase()}</td>
        </tr>
        <tr>
          <td>Ville:</td>
          <td>{parentData.ville?.toUpperCase()}</td>
        </tr>
      </table> */}
    </div>
  );
};

export default ParentInfo;
